(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finimade-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('finimade-signup')) {
  customElements.define('finimade-signup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.ready) return;
      this.ready = true;
      this.preview = this.dataset.preview === 'true';
      this.key = 'finimade-signup-' + this.dataset.campaign;
      this.state = {};
      try { this.state = JSON.parse(localStorage.getItem(this.key) || '{}'); } catch (_) {}
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dismiss()));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); });
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dismiss();
      });
      this.querySelector('form')?.addEventListener('submit', event => {
        if (this.deadline && Date.now() >= this.deadline && !this.preview) {
          event.preventDefault();
          this.expire();
        } else {
          this.state.pending = Date.now();
          this.save();
        }
      });
      const success = this.querySelector('[data-success]');
      const returned = Boolean(this.state.pending && Date.now() - this.state.pending < 30 * 60 * 1000);
      if (success && (returned || this.preview)) {
        this.state.subscribed = true;
        delete this.state.pending;
        this.save();
        this.open();
        return;
      }
      if (this.state.dismissed || this.state.subscribed) { if (!this.preview) return; }
      this.deadline = this.preview ? Date.now() + 180000 : Number(this.state.deadline || 0);
      if (this.deadline && this.deadline <= Date.now()) return;
      this.timeout = setTimeout(() => {
        if (!this.isConnected) return;
        if (!this.deadline) {
          this.deadline = Date.now() + 180000;
          this.state.deadline = this.deadline;
          this.save();
        }
        this.open();
        this.tick();
        this.interval = setInterval(() => this.tick(), 500);
      }, returned && this.querySelector('[data-errors]') ? 0 : 3000);
    }
    save() {
      if (this.preview) return;
      try { localStorage.setItem(this.key, JSON.stringify(this.state)); } catch (_) {}
    }
    open() {
      if (!this.dialog.open) {
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      }
    }
    tick() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const timer = this.querySelector('[data-timer]');
      if (timer) timer.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      if (!seconds) this.expire();
    }
    expire() {
      this.querySelectorAll('button[type="submit"], input').forEach(input => input.disabled = true);
      this.dismiss();
    }
    dismiss() {
      this.state.dismissed = true;
      this.save();
      clearInterval(this.interval);
      this.dialog.close();
      this.previousFocus?.focus();
    }
    disconnectedCallback() {
      clearTimeout(this.timeout);
      clearInterval(this.interval);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finimade-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('finimade-reviews-carousel')) {
  customElements.define('finimade-reviews-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.fm-reviews__grid');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.rail || !this.prev || !this.next) return;
      this.update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.prev.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= max - 2;
      };
      this.move = (direction) => {
        const card = this.rail.querySelector('.fm-reviews__card');
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.rail.clientWidth;
        this.rail.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.rail.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.rail?.removeEventListener('scroll', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
